import { useState, useEffect } from 'react';
import { anotherInstance } from './hookConnect'

const useUserLength = () => {
  const [userLength, setUserLength] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUserLength = async () => {
      try {
        const response = await anotherInstance.get(`users/count`);
        setUserLength(response.data.count);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    fetchUserLength();
  }, []);

  return { userLength, loading, error };
};

export default useUserLength;
